import { StoryblokImage } from "@wojo/storyblok";
import { ContentAsset } from "../../../generated/graphql";
import styles from "./CollageLayout.module.scss";

export type CollageImageProps = {
    height: number;
    width: number;
    onClick: () => void;
    defer?: boolean;
} & ContentAsset;

export const CollageImage: React.FC<CollageImageProps> = ({
    height,
    width,
    onClick,
    filename,
    title,
    alt,
    id,
    name,
    defer,
    focus,
}) => {
    return (
        <button onClick={() => onClick()} aria-label={alt || "tour image"}>
            <StoryblokImage
                mobile={{
                    size: {
                        height,
                        width,
                    },
                    asset: {
                        filename,
                        title,
                        alt,
                        id,
                        name,
                        focus,
                    },
                }}
                defer={defer}
                imageClassName={styles["collage-image"]}
            />
        </button>
    );
};
